<template>
  <div class="v1-hdr-outer" id="v1headerScroll">
    <div class="v1-lmd-menu" id="v1MenuOpen">
      <nav>
        <ul class="menu-hide-desktop">
          <li class="dashboard-icon" id="dashboardLink" :class="{ active: $route.path === '/employee/dashboard' }">
            <router-link :to="'/employee/dashboard'">
              {{ constants.DASHBOARD_LINK }}
            </router-link>
          </li>
          <li class="files-icon">
            <router-link :to="'/employee/files'" id="filesLink" :class="{ active: $route.path === '/employee/files' }">
              {{ constants.FILES_LINK }}
            </router-link>
            <!-- <span class="notification-num">3</span> -->
          </li>
          <li class="chat-icon">
            <router-link :to="'/employee/chats'" id="chatLink" :class="{ active: $route.path === '/employee/chats' }">
              {{ constants.CHAT_LINK }}
            </router-link>
            <!-- <span class="notification-num">5</span> -->
          </li>
        </ul>
      </nav>
    </div>
    <header class="v1-lmd-header">
      <div class="container-fluid">
        <div class="custom-row">
          <div class="site-logo" id="siteLogo">
            <router-link :to="'/'">
              <img src="@/assets/lems-v1/images/logo.png" />
            </router-link>
          </div>
          <div class="after-login-menu hide-mobile">
            <ul>
              <li class="dashboard-icon" id="dashboardLink">
                <router-link :to="'/employee/dashboard'" :class="{ active: $route.path === '/employee/dashboard' }">
                  {{ constants.DASHBOARD_LINK }}
                </router-link>
              </li>
              <li class="files-icon">
                <router-link :to="'/employee/files'" id="filesLink" :class="{ active: $route.path === '/employee/files' }">
                  {{ constants.FILES_LINK }}
                </router-link>
                <!-- <span class="notification-num">3</span> -->
              </li>
              <li class="chat-icon">
                <router-link :to="'/employee/chats'" id="chatLink" :class="{ active: $route.path === '/employee/chats' }">
                  {{ constants.CHAT_LINK }}
                </router-link>
                <!-- <span class="notification-num">5</span> -->
              </li>
            </ul>
          </div>
          <div class="v1-lmd-hdr-right">
            <div class="v1-menu-icon">
              <button id="menuClick">
                <span class="hamb-top"></span> <span class="hamb-mid"></span>
                <span class="hamb-btm"></span>
              </button>
            </div>
            <div class="header-after-login">
              <div class="login-user-info">
                <a href="javascript:void(0);" id="profileDropDown">
                  <span>
                    <img :src="displayImage" />
                    <div class="user-status user-status-active"></div>
                  </span>
                  <i>
                    {{ constants.WELCOME_TEXT }}
                    {{ fullName }}
                  </i>
                </a>
              </div>
              <div class="hdr-dropdown">
                <div class="hdr-dropdown-in">
                  <ul>
                    <li>
                      <router-link :to="'/employee/profile'" id="profileLink">
                        {{ constants.PROFILE_LINK }}
                      </router-link>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click="logout"
                        id="logoutLink"
                      >
                        {{ constants.LOGOUT_LINK }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL, API_IMAGES_BASE_URL } from "@/config/api.config";
import eventBus from "@/utils/eventBus";

interface AvatarUrls {
  [key: string]: string;
}

interface UserProfileData {
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  designation: string;
  education: string;
  comapanyName: string;
  websiteUrl: string;
  contactNumber: string;
  aboutUs: string;
  avatarUrls: AvatarUrls;
  profileImage: string;
  projects: any[];
}

export default defineComponent({
  name: "Header",
  data() {
    return {
      constants,
      userProfileData: {
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
        designation: "",
        education: "",
        comapanyName: "",
        websiteUrl: "",
        contactNumber: "",
        aboutUs: "",
        avatarUrls: {} as AvatarUrls,
        profileImage: "",
        projects: [],
      } as UserProfileData,
    };
  },
  computed: {
    fullName(): string {
      const firstName = this.userProfileData.firstName || "";
      const lastName = this.userProfileData.lastName || "";
      return `${firstName} ${lastName}`.trim() || "User";
    },
    displayImage(): string {
      if (this.userProfileData.profileImage) {
        return `${API_IMAGES_BASE_URL}${this.userProfileData.profileImage}`;
      }

      if (
        this.userProfileData.avatarUrls &&
        Object.keys(this.userProfileData.avatarUrls).length > 0
      ) {
        const avatarUrls = this.userProfileData.avatarUrls;
        if (avatarUrls["48x48"]) {
          return avatarUrls["48x48"];
        } else if (avatarUrls["32x32"]) {
          return avatarUrls["32x32"];
        } else {
          return Object.values(avatarUrls)[0] as string;
        }
      }

      return "@/assets/lems-v1/images/default-user-img.jpg";
    },
  },
  async mounted() {
    await this.fetchUserProfile();

    // Listen for profile updates
    eventBus.on("profile-updated", this.fetchUserProfile);
  },
  beforeUnmount() {
    // Clean up event listener
    eventBus.off("profile-updated", this.fetchUserProfile);
  },
  methods: {
    async fetchUserProfile() {
      try {
        const username = localStorage.getItem("jira_user_username");
        if (!username) {
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/jira/profile/${username}/`
        );

        this.userProfileData = response.data.user;
      } catch (error) {
        console.error("Error fetching user profile in header:", error);
      }
    },
    logout() {
      localStorage.removeItem("is_jira_loggedIn");
      this.$router.push("/employee/login");
    },
  },
});
</script>
